import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Col, Form, Row } from "antd";
import { observer } from "mobx-react-lite";
import { useStores } from "../../../../../../../store/root.js";
import { spacing } from "../../../../../../../styles/spacing.js";
import { getPathInfo } from "../../../../../../../util/template/form.js";
import { getFormPropsByLanguage, getTranslationFlagElementStyle, hasTranslationFlagsChanged, onTranslationValueChange } from "../../../../../../../util/translation.js";
import { QuillEditorFormField } from "../../../../../../third-party/quill-editor-form.js";
import { LanguageIcon } from "../language-icon-addon/language-icon.js";
const TranslationQuillFormFieldEntry = observer(({ lang, flexPathConfig, formProps, quillEditorProps })=>{
    const form = Form.useFormInstance();
    const { rcbUserSettingsStore: { settings: { translationSettings } } } = useStores();
    const inputInfo = getPathInfo(flexPathConfig, lang);
    const { style } = getFormPropsByLanguage(lang, translationSettings);
    return /*#__PURE__*/ _jsx(Form.Item, {
        shouldUpdate: (prev, next)=>hasTranslationFlagsChanged(prev, next, inputInfo.flagNamePath),
        noStyle: true,
        children: ()=>{
            const flagStyle = getTranslationFlagElementStyle(form, inputInfo.flagNamePath);
            const dynamicQuillEditorProps = {
                ...quillEditorProps,
                style: {
                    ...flagStyle,
                    ...quillEditorProps?.style
                },
                onChange: ()=>{
                    onTranslationValueChange(form, inputInfo.flagNamePath, lang);
                }
            };
            return /*#__PURE__*/ _jsxs(Row, {
                gutter: [
                    10,
                    10
                ],
                style: {
                    ...style,
                    paddingTop: spacing.layout.content.paddingSmall,
                    flexFlow: "row"
                },
                children: [
                    /*#__PURE__*/ _jsx(Col, {
                        flex: 1,
                        children: /*#__PURE__*/ _jsx(QuillEditorFormField, {
                            namePath: inputInfo.namePath,
                            formProps: formProps,
                            quillEditorProps: dynamicQuillEditorProps
                        })
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        flex: "0",
                        children: /*#__PURE__*/ _jsx(LanguageIcon, {
                            lang: lang,
                            flexPathConfig: flexPathConfig
                        })
                    })
                ]
            }, inputInfo.key);
        }
    });
});
export { TranslationQuillFormFieldEntry };
